import { render, staticRenderFns } from "./NodeLegend.vue?vue&type=template&id=47a22c7d&scoped=true&"
import script from "./NodeLegend.vue?vue&type=script&lang=ts&"
export * from "./NodeLegend.vue?vue&type=script&lang=ts&"
import style0 from "./NodeLegend.vue?vue&type=style&index=0&id=47a22c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a22c7d",
  null
  
)

export default component.exports